import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { ServiceRouter } from '../../../services/core/http-service-router.service';
import { Config } from '../../../config/config';
import { METHOD_TYPE } from '../../../constants/service.constants';
import { Environment } from '../../../config/environment';
import { Subscription } from 'rxjs';
import { AppointmentsService } from 'src/app/services/scheduling/appointment/appointments.service';
import { PROCEDURE_CONSTANTS, APPOINTMENT_STATUS } from 'src/app/constants/scheduling.constants';

/**
 * Request a referral component
 */
@Component({
	selector: 'app-referral',
	templateUrl: './request-referral.component.html',
	styleUrls: ['./request-referral.component.scss'],
})
export class RequestReferralComponent implements OnInit, OnDestroy {
	/** List of  different medical specialities */
	specialities: any;
	/** Value from referral add details tab */
	details: any;
	/** Referral eligibility flag */
	hasEligibility: boolean = false;
	/** Referral eligibility message */
	eligibilityMessage = '';
	/** Referral top stepper selected index */
	selectedStepperIndex = 0;
	/** holds data carrier subscriptions */
	subscription: Subscription;
	/** Reset specialty form flag */
	reset: boolean = false;
	/** Procedure constants (Physical exam) */
	procedureConstants = PROCEDURE_CONSTANTS;
	/** Appointment status constants */
	apptStatus = APPOINTMENT_STATUS;
	/**
	 * @param serviceRouter service router
	 * @param config config file that holds the service end points
	 * @param spinner spinner component
	 * @param environment - environment file that supplies env values
	 * @param appointmentService - appointment service
	 */
	constructor(
		private router: Router,
		private spinner: SpinnerComponent,
		private serviceRouter: ServiceRouter,
		private config: Config,
		private environment: Environment,
		private appointmentService: AppointmentsService
	) {}

	/**
	 * Component initialization - fetches referral information
	 */
	ngOnInit() {
		this.getReferrals();
	}

	/**
	 * Retrieving list of referrals if the patient has eligibility
	 * Else displaying an eligibility message based on upcoming physical exam status
	 */
	getReferrals() {
		this.spinner.startLoader();
		this.subscription = this.serviceRouter
			.makeRequest(
				this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
				this.config.url.referralApi.getCurrentReferrals,
				METHOD_TYPE.SECURED_GET,
				''
			)
			.subscribe(
				(data: any) => {
					this.spinner.stopLoader();
					if (data.patientEligiblity) {
						this.hasEligibility = true;
					} else {
						if (this.appointmentService.hasUpcomingPE().value) {
							this.eligibilityMessage =
								'Referral Coordination will be available to you for a full year once you complete your physical exam.';
						} else {
							this.eligibilityMessage =
								'Referral Coordination is available for a full year once you complete your physical exam. If you haven\'t had your exam, <a href="/scheduling/create/appointment">schedule</a> one now.';
						}
						this.eligibilityMessage = btoa(JSON.stringify(this.eligibilityMessage));
						this.router.navigate(['/wellness/referral/eligibility'], {
							queryParams: { data: this.eligibilityMessage },
						});
					}
				},
				err => {
					// Error
					this.spinner.stopLoader();
				}
			);
	}
	/**
	 * value from select specialities tab
	 * @param specialities
	 */
	valueFromSelectSpecialty(specialities) {
		this.specialities = specialities;
	}
	/**
	 * Value from add details tab
	 * @param details
	 */
	valueFromAddDetails(details) {
		this.details = {};
		setTimeout(() => {
			this.details = details;
		}, 0);
	}
	/**
	 * Detecting change in stepper to update the selected stepper index value
	 * @param e
	 */
	changeInStepper(e) {
		this.selectedStepperIndex = e.selectedIndex;
	}
	/**
	 * Destroys component
	 */
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
